import services from 'services/services';

// Import types
import type { Document } from 'types/api/documents';

export const fetchDocumentByAlias = async (alias: string): Promise<Document> =>
	services.get<Document>(`/documents/byAlias/${alias}`).then((res) => res.data);
